<!-- eslint-disable vue/multi-word-component-names -->
<!-- 组件文件 -->
<template>
  <div class="box">
    <com-header></com-header>
    <div class="container">
      <div class="wechatAlert" v-if="isWxA">
        <p>{{ $t('common.alertInfo1') }}<span>{{ $t('common.alertInfo2') }}</span></p>
        <button @click="isWxA = false">×</button>
      </div>
      <div class="banner">
        <div class="bannerLogo alc">
          <img src="../assets/logo.png" />
          <h3>{{ $t('app') }}</h3>
        </div>
        <p>{{ $t('banner.slogan2') }}</p>
      </div>
      <div class="downList">
        <ul>
          <li v-for="item in appStoreList" :key="item.id" @click="downloadApp(item)">
            <div class="downItem">
              <i class="iconfont" :class="item.icon"></i>
              <p>{{ item.name }}</p>
            </div>
          </li>
          <li></li>
        </ul>
      </div>
      <div class="contList">
        <h3>{{ $t('hexinyingyong.title') }}</h3>
        <ul>
          <li v-for="item in hexin" :key="item.id">
            <div class="contItem">
              <h4>{{ item.title }}</h4>
              <p>{{ item.cont }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="contList">
        <h3>{{ $t('hexinyingyong.title2') }}</h3>
        <ul>
          <li v-for="item in yinyong" :key="item.id">
            <div class="contItem">
              <h4>{{ item.title }}</h4>
              <p>{{ item.cont }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <com-fotter></com-fotter>
  </div>

</template>
<script>
import comHeader from '@/components/header.vue'
import comFotter from '@/components/fotter.vue'
export default {
  components: { comHeader, comFotter },
  data () {
    return {
      isWxA: false
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    },
    appStoreList () {
      if (this.$i18n.locale === 'zh') {
        return [{
          id: 1,
          name: this.$t('download.apple'),
          href: 'javascript:;',
          img: 'AppStore.png',
          icon: 'icon-pingguo'
        }, {
          id: 4,
          name: this.$t('download.android'),
          href: 'javascript:;',
          img: 'anzhuo.png',
          icon: 'icon-anzhuo'
        }, {
          id: 3,
          name: this.$t('download.honor'),
          href: 'javascript:;',
          img: 'honor.png',
          icon: 'icon-rongyao'
        }, {
          id: 5,
          name: this.$t('download.huawei'),
          href: 'javascript:;',
          img: 'huawei.png',
          icon: 'icon-huawei'
        }, {
          id: 6,
          name: this.$t('download.mi'),
          href: 'javascript:;',
          img: 'mi.png',
          icon: 'icon-XiaoMi-1'
        }, {
          id: 7,
          name: this.$t('download.oppo'),
          href: 'javascript:;',
          img: 'oppo.png',
          icon: 'icon-oppo'
        }, {
          id: 8,
          name: this.$t('download.vivo'),
          href: 'javascript:;',
          img: 'vivo.png',
          icon: 'icon-vivo'
        }]
      } else {
        return [{
          id: 1,
          name: this.$t('download.apple'),
          href: 'javascript:;',
          img: 'AppStore.png',
          icon: 'icon-pingguo'
        }, {
          id: 4,
          name: this.$t('download.android'),
          href: 'javascript:;',
          img: 'anzhuo.png',
          icon: 'icon-anzhuo'
        }, {
          id: 2,
          name: this.$t('download.google'),
          href: 'javascript:;',
          img: 'google.png',
          icon: 'icon-gugeplay'
        }, {
          id: 5,
          name: this.$t('download.huawei'),
          href: 'javascript:;',
          img: 'huawei.png',
          icon: 'icon-huawei'
        }, {
          id: 3,
          name: this.$t('download.honor'),
          href: 'javascript:;',
          img: 'honor.png',
          icon: 'icon-rongyao'
        }]
      }
    },
    hexin () {
      return [{
        id: 1,
        title: this.$t('hexinyingyong.t1'),
        cont: this.$t('hexinyingyong.j1')
      }, {
        id: 2,
        title: this.$t('hexinyingyong.t2'),
        cont: this.$t('hexinyingyong.j2')
      }, {
        id: 3,
        title: this.$t('hexinyingyong.t3'),
        cont: this.$t('hexinyingyong.j3')
      }, {
        id: 4,
        title: this.$t('hexinyingyong.t4'),
        cont: this.$t('hexinyingyong.j4')
      }, {
        id: 5,
        title: this.$t('hexinyingyong.t5'),
        cont: this.$t('hexinyingyong.j5')
      }, {
        id: 6,
        title: this.$t('hexinyingyong.t6'),
        cont: this.$t('hexinyingyong.j6')
      }]
    },
    yinyong () {
      return [{
        id: 1,
        title: this.$t('hexinyingyong.t7'),
        cont: this.$t('hexinyingyong.j7')
      }, {
        id: 2,
        title: this.$t('hexinyingyong.t8'),
        cont: this.$t('hexinyingyong.j8')
      }, {
        id: 3,
        title: this.$t('hexinyingyong.t9'),
        cont: this.$t('hexinyingyong.j9')
      }, {
        id: 4,
        title: this.$t('hexinyingyong.t10'),
        cont: this.$t('hexinyingyong.j10')
      }, {
        id: 5,
        title: this.$t('hexinyingyong.t11'),
        cont: this.$t('hexinyingyong.j11')
      }, {
        id: 6,
        title: this.$t('hexinyingyong.t12'),
        cont: this.$t('hexinyingyong.j12')
      }]
    }

  },
  mounted () {
    console.log('this.$i18n.locale', this.$i18n.locale)
    // 确保DOM完全渲染后初始化
    this.$nextTick(() => {
      new this.$wow({
        boxClass: 'wow',
        animateClass: 'animated', // 动画类名前缀
        offset: 0,
        mobile: false,
        live: true
      }).init()
    })
  },
  methods: {
    downloadApp (appInfo) {
      const isWeChat = this.isWechatBrowser()
      switch (appInfo.id) {
        case 1:
          console.log('apple')
          if (isWeChat) {
            this.isWxA = true
          }
          // window.location.href = 'https://apps.apple.com/us/app/nebularec/id6744643148'
          window.open('https://apps.apple.com/us/app/nebularec/id6744643148', '_blank')
          break
        case 2:
          console.log('Play 商店')
          // window.location.href = 'https://play.google.com/store/apps/details?id=com.palmzem.voicerecorder'
          window.open('https://play.google.com/store/apps/details?id=com.palmzem.voicerecorder', '_blank')
          break
        case 3:
          console.log('荣耀应用商店')
          window.open('https://appmarket-h5.cloud.honor.com/h5/share/latest/index.html?shareId=1976936135042260992#/', '_blank')
          // alert(this.$t('download.appstore'))
          break
        case 4:
          console.log('安卓下载')
          if (isWeChat) {
            this.isWxA = true
          } else {
            window.open('https://cos-rec.nebula-ai.net/apk/rec.apk')
          }
          break
        case 5:
          console.log('华为下载')
          window.open('https://appgallery.huawei.com/app/C114917975', '_blank')
          break
        case 6:
          console.log('小米下载')
          window.open('https://app.xiaomi.com/details?id=com.palmzem.voicerecorder&ref=search', '_blank')
          break
        case 7:
          console.log('oppo下载')
          alert(this.$t('download.appstore'))
          break
        case 8:
          console.log('vivo下载')
          window.open('https://h5.appstore.vivo.com.cn/index.html#/details?search_word=nebularec&search_action=4&app_id=4078061&app_pos=1&source=5&appId=4078061&frompage=searchResultApp&listpos=1', '_blank')
          break
        default:
          alert('敬请期待！')
          console.log('Unknown fruit')
      }
    },
    isWechatBrowser () {
      const ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('micromessenger') !== -1
    }
  }
}
</script>

<style scoped>
ul,
ol,
p {
  margin: 0;
  padding: 0;
  list-style: none;
}

.container {
  position: relative;
  max-width: 1400px;
  margin: 60px auto;
  padding: 10px 5%;
  user-select: none
}

.wechatAlert {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: rgba(54, 65, 83, 0.95);
  padding: 10px;
  color: #fff;
}

.wechatAlert p {
  line-height: 25px;
}

.wechatAlert p span {
  display: block;
}

.wechatAlert button {
  background: none;
  border: none;
  font-size: 30px;
  color: #fff;
}

.title {
  margin: 50px 0;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
}

.highlights img {
  max-width: 1000px;
  width: 100%;
  text-align: center;
}

.banner {
  margin-top: 50px;
}

.bannerLogo img {
  width: 40px;
}

.bannerLogo h3 {
  font-size: 30px;
}

.banner p {
  margin-top: 10px;
  ;
  text-align: center;
  color: #4A5565;
  line-height: 28px;
  font-size: 18px;
}

.downList {
  margin: 20px auto;
}

.downList ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.downList ul li {
  width: 24%;
  margin: 5px 0;
}

.downItem {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 22px;
  height: 44px;
  border-radius: 8px;
  background: linear-gradient(to bottom, #155DFC, #1447E6);
  color: #fff;
  text-align: center;
}

.downItem i {
  width: 50px;
}

.downItem p {
  flex-grow: 1;
  text-align: left;
}

.contList {
  margin: 100px auto 0;
}

.contList h3 {
  margin-bottom: 20px;
  font-size: 24px;
  text-align: center;
  font-weight: bold;
}

.contList ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.contList ul li {
  width: 47%;
  text-align: center;
  margin: 5px 0;
}

.contItem {
  padding: 20px 5px;
  border-radius: 16px;
  border: 1px solid #E5E7EB;
  background-color: #fff;
}

.contItem h4 {
  font-size: 16px;
  margin-bottom: 10px;
}

.contItem p {
  font-size: 14px;
  color: #6A7282;
}

@media (max-width: 800px) {
  .container {
    padding: 10px 2%;
  }

  .banner {
    margin-top: 20px;
  }

  .downList ul li {
    width: 48%;
  }

  .downItem {
    font-size: 12px;
    line-height: 15px;
  }

  .contList {
    margin: 20px auto 0;
  }

  .contList ul li {
    width: 48%;
  }
}
</style>
